// components/Transferencias.jsx
import React, { useState, useEffect } from "react";
import api from "../services/api";
import "./Transferencias.css";
import { formatearFecha,obtenerFechaLocal } from '../utils/dateUtils';

const Transferencias = () => {
  const [transferencias, setTransferencias] = useState([]);
  const [almacenes, setAlmacenes] = useState([]);
  const [materiales, setMateriales] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mensaje, setMensaje] = useState({ texto: "", tipo: "" });
  const [modalAbierto, setModalAbierto] = useState(false);
  const [vistaActual, setVistaActual] = useState("todas");
  const [filtroEstado, setFiltroEstado] = useState("todas");
  const [categoriaFiltro, setCategoriaFiltro] = useState("");
  const [categorias, setCategorias] = useState([]);
  const [modalError, setModalError] = useState(null);
  const [modalDetalleLote, setModalDetalleLote] = useState(null);

  // ═══════════════════════════════════════════════════════════════
  // 🆕 ESTADO PARA TRANSFERENCIAS EN LOTE
  // ═══════════════════════════════════════════════════════════════
  const [tipoTransferencia, setTipoTransferencia] = useState('individual'); // 'individual' o 'lote'
  const [materialesLote, setMaterialesLote] = useState([]); // Array de materiales para lote
  const [materialTemporal, setMaterialTemporal] = useState({
    MaterialId: '',
    cantidad: ''
  });

  const [formData, setFormData] = useState({
    fecha: obtenerFechaLocal(),
    AlmacenOrigenId: "",
    AlmacenDestinoId: "",
    ProyectoId: "",
    MaterialId: "",
    cantidad: "",
    observacion: "",
  });

  useEffect(() => {
    cargarDatos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vistaActual, filtroEstado]);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      
      const params = {};
      if (vistaActual === "pendientes") {
        params.estado = "pendiente_aprobacion";
      } else if (filtroEstado !== "todas") {
        params.estado = filtroEstado;
      }

      const [transRes, almRes, matRes, proyRes, catRes] = await Promise.all([
        api.get("/transferencias", { params }),
        api.get("/almacenes"),
        api.get("/materiales"),
        api.get("/proyectos/activos"),
        api.get("/categorias"),
      ]);

      setTransferencias(Array.isArray(transRes.data) ? transRes.data : []);
      setAlmacenes(Array.isArray(almRes.data) ? almRes.data : []);
      setMateriales(Array.isArray(matRes.data) ? matRes.data : []);
      setProyectos(Array.isArray(proyRes.data) ? proyRes.data : []);
      setCategorias(Array.isArray(catRes.data) ? catRes.data : []);
    } catch (error) {
      console.error("Error al cargar datos:", error);
      mostrarMensaje("Error al cargar datos", "error");
      setTransferencias([]);
      setAlmacenes([]);
      setMateriales([]);
      setProyectos([]);
      setCategorias([]); 
    } finally {
      setLoading(false);
    }
  };

  const mostrarMensaje = (texto, tipo) => {
    setMensaje({ texto, tipo });
    setTimeout(() => setMensaje({ texto: "", tipo: "" }), 5000);
  };

  const abrirModal = () => {
    setFormData({
    fecha: obtenerFechaLocal(),
      AlmacenOrigenId: "",
      AlmacenDestinoId: "",
      ProyectoId: "",
      MaterialId: "",
      cantidad: "",
      observacion: "",
    });
    setTipoTransferencia('individual');
    setMaterialesLote([]);
    setMaterialTemporal({ MaterialId: '', cantidad: '' });
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
  };

  // ═══════════════════════════════════════════════════════════════
  // 🆕 FUNCIONES PARA TRANSFERENCIAS EN LOTE
  // ═══════════════════════════════════════════════════════════════
  
 const agregarMaterialALote = () => {
  if (!materialTemporal.MaterialId || !materialTemporal.cantidad) {
    mostrarMensaje("Seleccione un material y cantidad", "error");
    return;
  }

  // Verificar que no esté duplicado
  if (materialesLote.find(m => m.MaterialId === parseInt(materialTemporal.MaterialId))) {
    mostrarMensaje("Este material ya está en la lista", "error");
    return;
  }

  const material = materiales.find(m => m.id === parseInt(materialTemporal.MaterialId));
  
  // ✅ CORRECCIÓN: Convertir cantidad a número con precisión
  const cantidadNumerica = Number(materialTemporal.cantidad);
  
  setMaterialesLote([
    ...materialesLote,
    {
      MaterialId: parseInt(materialTemporal.MaterialId),
      cantidad: Number(cantidadNumerica.toFixed(2)), // ✅ Asegurar 2 decimales
      nombre: material.nombre,
      codigo: material.codigo
    }
  ]);

    // Limpiar campos
    setMaterialTemporal({ MaterialId: '', cantidad: '' });
  };

  const quitarMaterialDeLote = (MaterialId) => {
    setMaterialesLote(materialesLote.filter(m => m.MaterialId !== MaterialId));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.AlmacenOrigenId === formData.AlmacenDestinoId) {
      mostrarMensaje("El almacén origen y destino deben ser diferentes", "error");
      return;
    }

    // Preparar datos según tipo
    let datosEnvio = {
      tipo: tipoTransferencia,
      fecha: formData.fecha,
      AlmacenOrigenId: parseInt(formData.AlmacenOrigenId),
      AlmacenDestinoId: parseInt(formData.AlmacenDestinoId),
      ProyectoId: formData.ProyectoId ? parseInt(formData.ProyectoId) : null,
      observacion: formData.observacion
    };

    if (tipoTransferencia === 'individual') {
      if (!formData.MaterialId || !formData.cantidad) {
        mostrarMensaje("Debe especificar material y cantidad", "error");
        return;
      }
      datosEnvio.MaterialId = parseInt(formData.MaterialId);
      datosEnvio.cantidad = Number(formData.cantidad);

    } else {
      if (materialesLote.length === 0) {
        mostrarMensaje("Debe agregar al menos un material al lote", "error");
        return;
      }
      datosEnvio.materiales_lote = materialesLote;
    }

    try {
      await api.post("/transferencias", datosEnvio);
      mostrarMensaje(
        `✅ Transferencia ${tipoTransferencia === 'lote' ? 'en lote' : 'individual'} registrada correctamente`, 
        "success"
      );
      cerrarModal();
      cargarDatos();
    } catch (error) {
      console.error("Error al crear transferencia:", error);
      console.error("📛 Respuesta del servidor:", error.response?.data);
      
      cerrarModal();
      
      const mensajeError = error.response?.data?.error || error.response?.data?.mensaje;
      
      if (mensajeError && mensajeError.includes("Stock insuficiente")) {
        setModalError({
          titulo: "⚠️ Stock Insuficiente",
          mensaje: mensajeError,
          sugerencia: "Este material puede estar asignado a proyectos específicos. " +
                      "Usa el botón 📍 'Ver Ubicaciones' en la lista de Materiales " +
                      "para ver dónde está el stock disponible.",
          tipo: "warning"
        });
      } else {
        mostrarMensaje(mensajeError || "Error al crear transferencia", "error");
      }
    }
  };

  const aprobarTransferencia = async (id) => {
    if (!window.confirm("¿Aprobar esta transferencia?")) return;

    try {
      await api.put(`/transferencias/aprobar/${id}`);
      mostrarMensaje("✅ Transferencia aprobada correctamente", "success");
      cargarDatos();
    } catch (error) {
      console.error("Error al aprobar:", error);
      mostrarMensaje(
        error.response?.data?.error || "Error al aprobar transferencia",
        "error"
      );
    }
  };

  const rechazarTransferencia = async (id) => {
    const motivo = window.prompt("Motivo del rechazo:");
    if (!motivo) return;

    try {
      await api.put(`/transferencias/rechazar/${id}`, { motivo });
      mostrarMensaje("✅ Transferencia rechazada", "success");
      cargarDatos();
    } catch (error) {
      console.error("Error al rechazar:", error);
      mostrarMensaje(
        error.response?.data?.error || "Error al rechazar transferencia",
        "error"
      );
    }
  };

  const getEstadoBadge = (estado) => {
    const badges = {
      pendiente_aprobacion: { texto: "⏳ Pendiente", clase: "badge-warning" },
      aprobada: { texto: "✅ Aprobada", clase: "badge-success" },
      rechazada: { texto: "❌ Rechazada", clase: "badge-danger" },
    };
    return badges[estado] || badges.pendiente_aprobacion;
  };

  // ═══════════════════════════════════════════════════════════════
  // 🆕 FUNCIÓN PARA MOSTRAR DETALLE DE LOTE
  // ═══════════════════════════════════════════════════════════════
  const verDetalleLote = (transferencia) => {
    setModalDetalleLote(transferencia);
  };

  if (loading) {
    return <div className="loading">Cargando transferencias...</div>;
  }

  const pendientes = transferencias.filter(
    (t) => t.estado === "pendiente_aprobacion"
  );

  const transferenciasFiltradas = () => {
    if (vistaActual === "pendientes") {
      return pendientes;
    }
    if (filtroEstado === "todas") {
      return transferencias;
    }
    return transferencias.filter((t) => t.estado === filtroEstado);
  };

  return (
    <div className="transferencias-container">
      {/* HEADER */}
      <div className="transferencias-header">
        <div>
          <h1 className="titulo-principal">
            <span className="icono">🔄</span>
            Transferencias Entre Almacenes
          </h1>
        </div>
        <button className="btn btn-primary" onClick={abrirModal}>
          ➕ Nueva Transferencia
        </button>
      </div>

      {/* MENSAJES */}
      {mensaje.texto && (
        <div className={`mensaje mensaje-${mensaje.tipo}`}>
          {mensaje.texto}
        </div>
      )}

      {/* TABS */}
      <div className="tabs">
        <button
          className={`tab ${vistaActual === "todas" ? "activo" : ""}`}
          onClick={() => setVistaActual("todas")}
        >
          📋 Todas ({transferencias.length})
        </button>
        <button
          className={`tab ${vistaActual === "pendientes" ? "activo" : ""}`}
          onClick={() => setVistaActual("pendientes")}
        >
          ⏳ Pendientes ({pendientes.length})
        </button>
      </div>

      {/* FILTROS */}
      {vistaActual === "todas" && (
        <div className="filtros">
          <select
            value={filtroEstado}
            onChange={(e) => setFiltroEstado(e.target.value)}
            className="select-filtro"
          >
            <option value="todas">Todos los estados</option>
            <option value="pendiente_aprobacion">⏳ Pendiente</option>
            <option value="aprobada">✅ Aprobada</option>
            <option value="rechazada">❌ Rechazada</option>
          </select>
        </div>
      )}

      {/* TABLA */}
      <div className="tabla-container">
        <table className="tabla-transferencias">
          <thead>
            <tr>
              <th>CÓDIGO</th>
              <th>FECHA</th>
              <th>MATERIAL</th>
              <th>CANTIDAD</th>
              <th>ORIGEN → DESTINO</th>
              <th>PROYECTO</th>
              <th>ESTADO</th>
              <th>ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            {transferenciasFiltradas().map((trans) => {
              const badge = getEstadoBadge(trans.estado);
              const esLote = trans.tipo === 'lote';
              
              return (
                <tr key={trans.id}>
                  <td>
                    <strong>{trans.codigo}</strong>
                  </td>
                  <td>{formatearFecha(trans.fecha)}</td>
                  <td>
                    {esLote ? (
                      <div 
                        style={{ cursor: 'pointer', color: '#3b82f6', fontWeight: '600' }}
                        onClick={() => verDetalleLote(trans)}
                      >
                        📦 LOTE ({trans.materiales_lote?.length || 0} items)
                      </div>
                    ) : (
                      <>
                        {trans.material?.nombre || "N/A"}
                        {trans.material?.codigo && (
                          <div className="codigo-material">
                            {trans.material.codigo}
                          </div>
                        )}
                      </>
                    )}
                  </td>
                  <td>
                    {esLote ? (
                      <span style={{ color: '#64748b', fontSize: '0.9em' }}>
                        {trans.materiales_lote?.length || 0} materiales
                      </span>
                    ) : (
                      <strong>{trans.cantidad}</strong>
                    )}
                  </td>
                  <td>
                    <div className="ruta-transferencia">
                      <span className="almacen-origen">
                        {trans.almacen_origen?.nombre || "N/A"}
                      </span>
                      <span className="flecha">→</span>
                      <span className="almacen-destino">
                        {trans.almacen_destino?.nombre || "N/A"}
                      </span>
                    </div>
                  </td>
                  <td>
                    {trans.proyecto ? (
                      <span className="badge badge-info">
                        🏗️ {trans.proyecto.nombre}
                      </span>
                    ) : (
                      <span className="texto-secundario">-</span>
                    )}
                  </td>
                  <td>
                    <span className={`badge ${badge.clase}`}>
                      {badge.texto}
                    </span>
                  </td>
                  <td>
                    {trans.estado === "pendiente_aprobacion" && (
                      <div className="acciones">
                        <button
                          className="btn-accion btn-aprobar"
                          onClick={() => aprobarTransferencia(trans.id)}
                          title="Aprobar"
                        >
                          ✓
                        </button>
                        <button
                          className="btn-accion btn-rechazar"
                          onClick={() => rechazarTransferencia(trans.id)}
                          title="Rechazar"
                        >
                          ✕
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {transferenciasFiltradas().length === 0 && (
          <div className="sin-datos">
            No hay transferencias {vistaActual === "pendientes" ? "pendientes" : "registradas"}
          </div>
        )}
      </div>

      {/* ═══════════════════════════════════════════════════════════════ */}
      {/* MODAL CREAR TRANSFERENCIA */}
      {/* ═══════════════════════════════════════════════════════════════ */}
      {modalAbierto && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal-contenido" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>🔄 Nueva Transferencia</h2>
              <button className="btn-cerrar" onClick={cerrarModal}>
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              {/* ───────────────────────────────────────────────────────── */}
              {/* 🆕 TOGGLE TIPO DE TRANSFERENCIA */}
              {/* ───────────────────────────────────────────────────────── */}
              <div className="form-section">
                <label className="label-seccion">Tipo de Transferencia</label>
                <div className="tipo-toggle">
                  <button
                    type="button"
                    className={`toggle-btn ${tipoTransferencia === 'individual' ? 'active' : ''}`}
                    onClick={() => setTipoTransferencia('individual')}
                  >
                    📦 Individual
                  </button>
                  <button
                    type="button"
                    className={`toggle-btn ${tipoTransferencia === 'lote' ? 'active' : ''}`}
                    onClick={() => setTipoTransferencia('lote')}
                  >
                    📦📦 Lote (Múltiples)
                  </button>
                </div>
              </div>

              {/* ───────────────────────────────────────────────────────── */}
              {/* CAMPOS COMUNES */}
              {/* ───────────────────────────────────────────────────────── */}
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    Fecha <span className="required">*</span>
                  </label>
                  <input
                    type="Date"
                    value={formData.fecha}
                    onChange={(e) =>
                      setFormData({ ...formData, fecha: e.target.value })
                    }
                    required
                  />
                </div>

  <div className="form-group">
    <label>
      Almacén Origen <span className="required">*</span>
    </label>
    <select
      value={formData.AlmacenOrigenId}
      onChange={(e) =>
        setFormData({ ...formData, AlmacenOrigenId: e.target.value })
      }
      required
    >
      <option value="">Seleccione...</option>
      {almacenes
        .filter(alm => alm.id !== parseInt(formData.AlmacenDestinoId)) // No mostrar el destino seleccionado
        .map((alm) => (
          <option key={alm.id} value={alm.id}>
            {alm.nombre}
          </option>
        ))}
    </select>
  </div>

  <div className="form-group">
    <label>
      Almacén Destino <span className="required">*</span>
    </label>
    <select
      value={formData.AlmacenDestinoId}
      onChange={(e) =>
        setFormData({ ...formData, AlmacenDestinoId: e.target.value })
      }
      required
    >
      <option value="">Seleccione...</option>
      {almacenes
        .filter(alm => alm.id !== parseInt(formData.AlmacenOrigenId)) // No mostrar el origen seleccionado
        .map((alm) => (
          <option key={alm.id} value={alm.id}>
            {alm.nombre}
          </option>
        ))}
    </select>
  </div>

                <div className="form-group">
                  <label>Proyecto (Opcional)</label>
                  <select
                    value={formData.ProyectoId}
                    onChange={(e) =>
                      setFormData({ ...formData, ProyectoId: e.target.value })
                    }
                  >
                    <option value="">Sin proyecto específico</option>
                    {proyectos.map((proy) => (
                      <option key={proy.id} value={proy.id}>
                        {proy.nombre}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

            {/* ───────────────────────────────────────────────────────── */}
{/* 📦 MODO INDIVIDUAL */}
{/* ───────────────────────────────────────────────────────── */}
{tipoTransferencia === 'individual' && (
  <div className="form-section">
    <label className="label-seccion">📦 Material a Transferir</label>
    
    <div className="form-group">
      <label>Categoría (Filtro)</label>
      <select
        value={categoriaFiltro}
        onChange={(e) => setCategoriaFiltro(e.target.value)}
      >
        <option value="">Todas las categorías</option>
        {categorias.map((cat) => (
          <option key={cat.id} value={cat.id}>
            {cat.nombre}
          </option>
        ))}
      </select>
    </div>

    {/* CAMBIA ESTE CONTENEDOR - Mismo que en Lote */}
    <div className="agregar-material-lote">
      <div className="form-grid">
        <div className="form-group">
          <label>
            Material <span className="required">*</span>
          </label>
          <select
            value={formData.MaterialId}
            onChange={(e) =>
              setFormData({ ...formData, MaterialId: e.target.value })
            }
            required
          >
            <option value="">Seleccione...</option>
            {materiales
              .filter((m) =>
                categoriaFiltro ? m.CategoriaId === parseInt(categoriaFiltro) : true
              )
              .map((mat) => (
                <option key={mat.id} value={mat.id}>
                  {mat.nombre} {mat.codigo && `(${mat.codigo})`}
                </option>
              ))}
          </select>
        </div>

        <div className="form-group">
          <label>
            Cantidad <span className="required">*</span>
          </label>
          <input
            type="number"
            step="0.01"
            min="0.01"
            value={formData.cantidad}
            onChange={(e) => {
              const valor = e.target.value;
              setFormData({ 
                ...formData, 
                cantidad: valor === '' ? '' : Number(valor)
              });
            }}
            onBlur={(e) => {
              if (e.target.value) {
                const valorNumerico = Number(e.target.value);
                setFormData({ 
                  ...formData, 
                  cantidad: Number(valorNumerico.toFixed(2))  // ← Número, no string
                });
              }
            }}
            placeholder="0.00"
            required
          />
        </div>

        {/* Este espacio vacío para mantener la misma estructura de 3 columnas */}
        <div style={{ visibility: 'hidden' }}>
          <button style={{ opacity: 0 }}>Espacio</button>
        </div>
      </div>
    </div>
  </div>
)}
            {/* ───────────────────────────────────────────────────────── */}
{/* 📦📦 MODO LOTE */}
{/* ───────────────────────────────────────────────────────── */}
{tipoTransferencia === 'lote' && (
  <div className="form-section">
    <label className="label-seccion">📦 Materiales del Lote</label>
    
    {/* Agregar Material */}
    <div className="agregar-material-lote">
      <div className="form-group">
        <label>Categoría (Filtro)</label>
        <select
          value={categoriaFiltro}
          onChange={(e) => setCategoriaFiltro(e.target.value)}
        >
          <option value="">Todas las categorías</option>
          {categorias.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.nombre}
            </option>
          ))}
        </select>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label>Material</label>
          <select
            value={materialTemporal.MaterialId}
            onChange={(e) =>
              setMaterialTemporal({ ...materialTemporal, MaterialId: e.target.value })
            }
          >
            <option value="">Seleccione...</option>
            {materiales
              .filter((m) =>
                categoriaFiltro ? m.CategoriaId === parseInt(categoriaFiltro) : true
              )
              .map((mat) => (
                <option key={mat.id} value={mat.id}>
                  {mat.nombre} {mat.codigo && `(${mat.codigo})`}
                </option>
              ))}
          </select>
        </div>

        <div className="form-group">
          <label>Cantidad</label>
         <input
  type="number"
  step="0.01"
  min="0.01"
  value={materialTemporal.cantidad}
  onChange={(e) => {
    const valor = e.target.value;
    setMaterialTemporal({ 
      ...materialTemporal, 
      cantidad: valor === '' ? '' : Number(valor)
    });
  }}
  onBlur={(e) => {
    if (e.target.value) {
      const valorNumerico = Number(e.target.value);
      setMaterialTemporal({ 
        ...materialTemporal, 
        cantidad: Number(valorNumerico.toFixed(2))  // ← Número, no string
      });
    }
  }}
  placeholder="0.00"
/>
        </div>

        {/* CORREGIDO: Botón directamente, no dentro de form-group */}
        <button
          type="button"
          className="btn btn-primary"
          onClick={agregarMaterialALote}
          style={{ height: '46px', marginBottom: '0' }}
        >
          ➕ Agregar al Lote
        </button>
      </div>
    </div>


                 {/* Lista de Materiales Agregados */}
    {materialesLote.length > 0 && (
      <div className="materiales-lote-lista">
        <h4>Materiales agregados ({materialesLote.length}):</h4>
        <table className="tabla-materiales-lote">
          <thead>
            <tr>
              <th>Material</th>
              <th>Código</th>
              <th>Cantidad</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {materialesLote.map((item) => (
              <tr key={item.MaterialId}>
                <td>{item.nombre}</td>
                <td>{item.codigo}</td>
                <td><strong>{item.cantidad}</strong></td>
                <td>
                  <button
                    type="button"
                    className="btn-accion btn-rechazar"
                    onClick={() => quitarMaterialDeLote(item.MaterialId)}
                    title="Quitar"
                  >
                    ✕
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}{materialesLote.length === 0 && (
      <div className="sin-materiales-lote">
        ℹ️ Agregue al menos un material para crear la transferencia en lote
      </div>
    )}
  </div>
)}

              {/* ───────────────────────────────────────────────────────── */}
              {/* OBSERVACIONES */}
              {/* ───────────────────────────────────────────────────────── */}
              <div className="form-group full-width">
                <label>Observación</label>
                <textarea
                  value={formData.observacion}
                  onChange={(e) =>
                    setFormData({ ...formData, observacion: e.target.value })
                  }
                  rows="3"
                  placeholder="Observaciones opcionales..."
                />
              </div>

              {/* ───────────────────────────────────────────────────────── */}
              {/* BOTONES */}
              {/* ───────────────────────────────────────────────────────── */}
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  💾 Guardar Transferencia
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ═══════════════════════════════════════════════════════════════ */}
      {/* 🆕 MODAL DETALLE LOTE */}
      {/* ═══════════════════════════════════════════════════════════════ */}
      {modalDetalleLote && (
        <div className="modal-overlay" onClick={() => setModalDetalleLote(null)}>
          <div className="modal-contenido modal-detalle-lote" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>📦 Detalle de Transferencia en Lote</h2>
              <button className="btn-cerrar" onClick={() => setModalDetalleLote(null)}>
                ✕
              </button>
            </div>

            <div className="detalle-lote-info">
              <p><strong>Código:</strong> {modalDetalleLote.codigo}</p>
              <p><strong>Fecha:</strong> {formatearFecha(modalDetalleLote.fecha)}</p>
              <p><strong>Origen:</strong> {modalDetalleLote.almacen_origen?.nombre}</p>
              <p><strong>Destino:</strong> {modalDetalleLote.almacen_destino?.nombre}</p>
              {modalDetalleLote.proyecto && (
                <p><strong>Proyecto:</strong> {modalDetalleLote.proyecto.nombre}</p>
              )}
              <p><strong>Estado:</strong> <span className={`badge ${getEstadoBadge(modalDetalleLote.estado).clase}`}>
                {getEstadoBadge(modalDetalleLote.estado).texto}
              </span></p>
            </div>

            <h3>Materiales Transferidos:</h3>
            <table className="tabla-materiales-lote">
              <thead>
                <tr>
                  <th>Material</th>
                  <th>Código</th>
                  <th>Cantidad</th>
                  <th>Costo Unit.</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {modalDetalleLote.materiales_lote?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.nombre}</td>
                    <td>{item.codigo}</td>
                    <td><strong>{item.cantidad}</strong></td>
                    <td>RD$ {item.costo_unitario?.toFixed(2)}</td>
                    <td><strong>RD$ {item.valor_linea?.toFixed(2)}</strong></td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="4" style={{ textAlign: 'right', fontWeight: 'bold' }}>TOTAL:</td>
                  <td><strong>RD$ {modalDetalleLote.valor_total?.toFixed(2)}</strong></td>
                </tr>
              </tfoot>
            </table>

            {modalDetalleLote.observacion && (
              <div className="observacion-lote">
                <strong>Observación:</strong> {modalDetalleLote.observacion}
              </div>
            )}

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setModalDetalleLote(null)}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL ERROR */}
      {modalError && (
        <div className="modal-overlay" onClick={() => setModalError(null)}>
          <div className="modal-contenido modal-error" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{modalError.titulo}</h2>
              <button className="btn-cerrar" onClick={() => setModalError(null)}>
                ✕
              </button>
            </div>
            <div className="modal-body">
              <p className="mensaje-error">{modalError.mensaje}</p>
              {modalError.sugerencia && (
                <div className="sugerencia">
                  <p><strong>💡 Sugerencia:</strong></p>
                  <p>{modalError.sugerencia}</p>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => setModalError(null)}>
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Transferencias;